var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPenEdit = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.854.146a.5.5,0,0,0-.707,0L10.5,1.793,14.207,5.5l1.647-1.646a.5.5,0,0,0,0-.708l-3-3ZM13.5,6.207,9.793,2.5,3.293,9H3.5a.5.5,0,0,1,.5.5V10h.5a.5.5,0,0,1,.5.5V11h.5a.5.5,0,0,1,.5.5V12h.5a.5.5,0,0,1,.5.5v.207ZM6.032,13.675A.5.5,0,0,1,6,13.5V13H5.5a.5.5,0,0,1-.5-.5V12H4.5a.5.5,0,0,1-.5-.5V11H3.5a.5.5,0,0,1-.5-.5V10H2.5a.5.5,0,0,1-.175-.032l-.179.178a.5.5,0,0,0-.11.168l-2,5a.5.5,0,0,0,.65.65l5-2a.5.5,0,0,0,.168-.11l.178-.178Z",
    transform: "translate(4 4)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPenEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pen-edit.1ef8dfbc.svg";
export { ForwardRef as ReactComponent };